import Vue from 'vue'
import { mapGetters,mapActions } from 'vuex';

export default {

	data: () => ({
    parametros:{
      dialogError: false,
      mensaje: '',
      color: ''
    },

    respuestaAlerta:false,
    loader: true,
    cargar: false,
  }),
  
	methods: {
		validarrespuestaAlerta( error ){ 
			return new Promise( (resolve, reject) => {
				if( error.status == 400){
					resolve( error.body.message )
				}else{
					reject( error )
				}
			})
		},


		consultar_niveles_usuario(){
			return new Promise( (resolve) => {
				this.$http.get('niveles.activas').then((response)=>{
					resolve(response.data)
				}).catch(error =>{
					console.log('error niveles', error)
				})
			})
		},

		validarSuccess( mensaje ){
      this.cargar = false
      this.parametros.mensaje      = mensaje
      this.parametros.dialogError  = true 
      this.parametros.color        = 'success'
      this.respuestaAlerta         = true 
    },

    cerrarDialog( mensaje ){
      this.cargar = false
      this.parametros.mensaje      = ''
      this.parametros.dialogError  = false 
      this.parametros.color        = ''
      this.respuestaAlerta         = false 
    },

    validarError ( value ) {

      this.cargar = false

      const body =
        (value && value.body) ||
        (value && value.response && value.response.data) ||
        null

      const mensajeTexto = typeof value === 'string'
        ? value
        : (body && body.message)
          || (value && value.message)
          || ''
      const code =
        (body && body.code) ||
        (value && value.code) ||
        ''
      const status =
        (value && value.status) ||
        (value && value.response && value.response.status) ||
        null

      // El overlay grande de App.vue ya cubre este caso en el front actualizado
      if (
        code === 'ACCESO_BLOQUEADO' ||
        (typeof mensajeTexto === 'string' &&
          /acceso denegado.*actualizar su plataforma/i.test(mensajeTexto))
      ) {
        return
      }

      if (typeof value === 'string' && /sesión/i.test(value)) {
        this.parametros.mensaje      = value

        // Cerramos la sesión
        this.salirLogin()
        // Login usa path "/"; evitar NavigationDuplicated si ya estamos ahí
        this.$router.push({ name: 'Login' }).catch(() => {})

      }else if( status == 403 && body && body.message){
        this.parametros.mensaje      = body.message
      }else if( status == 400 || status == 500){
        this.parametros.mensaje      = (body && body.message) ? body.message : 'Error en la conexión con el servidor'
      }else if( status == 404 ){
        this.parametros.mensaje      = 'Ruta no encontrada, levantar un ticket, por favor'
      }else  if( status == 0 ){
        this.parametros.mensaje      = 'El servidor no se encuentra activo, contacta a sistemas'
      }else if (value && typeof value === 'object') {
        this.parametros.mensaje = (body && body.message) || value.message || value.sqlMessage || 'Error en la conexión con el servidor'
      }else{
        this.parametros.mensaje      = value
      }

      this.parametros.dialogError  = true 
      this.parametros.color        = '#FF2C2C'
      this.respuestaAlerta         = true 
    },

    validarErrorDirecto ( mensaje ) {
      this.cargar = false 
      this.parametros.mensaje      = mensaje
      this.parametros.dialogError  = true 
      this.parametros.color        = '#FF2C2C'
      this.respuestaAlerta = true 
    },
  }
}